var map = {
	"./alderman1200-2.png": 9551,
	"./alderman1200.png": 3246,
	"./alderman600-2.png": 2216,
	"./alderman600.png": 5721,
	"./aldermanlogin1080.jpg": 1403,
	"./aldermanlogin1200.jpg": 8689,
	"./banner1080.png": 3726,
	"./banner1920.png": 3561,
	"./logo192.png": 6504,
	"./logo512.png": 9788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1493;